import { Box, Breadcrumbs, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Tab, Table, TableBody, TableContainer, TableHead, Tabs, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { currencyOptions, useCommonStyles } from '../../utils';
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CommonTextField from '../Common/CommonTextField';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import { allowOnlyNumbers, Regex } from '../../utils/regex';
import ErrorMessage from '../Common/ErrorMessage';
import CommonRadioButton from '../Common/CommonRadioButton';
import { image } from '../../Redux/Actions/Vendor';
import ErrorHandler from '../../lib/errorHandler';
import CommonFileUpload from '../Common/CommonFileUpload';
import CommonLabel from '../Common/CommonLabel';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import IconBackground from '../Common/IconBackground';
import { addCustomer, getAllStateAndCity, updateCustomer } from '../../Redux/Actions/Customer';

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        margin: "30px",
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            backgroundColor: "transparent",
            alignItems: "start",
            color: "#555151",
            fontFamily: "Satoshi-Light",
            minWidth: "0px",
            fontSize: "18px"
        },
        "& .Mui-selected": {
            fontFamily: "Satoshi-Bold",
            color: theme.palette.primary.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}))

const customerStep = [
    { name: "Basic Details", value: 0, },
    { name: "Other Details", value: 1, },
    { name: "Address", value: 2, },
    { name: "Contact Person", value: 3, },
    { name: "Remarks", value: 4, },
];

const yesNoOptions = [
    { value: "Yes", name: "Yes" },
    { value: "No", name: "No" },
];
const placeOfSupplyOptions = [
    { value: "Location 1", name: "Location 1" },
    { value: "Location 2", name: "Location 2" },
    { value: "Location 3", name: "Location 3" },
    { value: "Location 4", name: "Location 4" },
    { value: "Location 5", name: "Location 5" },
    { value: "Location 6", name: "Location 6" },
];
const salutationOptions = [
    { value: "Mr.", name: "Mr." },
    { value: "Mrs.", name: "Mrs." },
    { value: "Ms.", name: "Ms." },
    { value: "Miss", name: "Miss" },
    { value: "Dr.", name: "Dr." },
];

const statusOptions = [
    { label: "Active", value: "Active" },
    { label: "Expired", value: "Expired" },
];
const communicationChannelsOptions = [
    { label: "Email", value: "Email" },
    { label: "SMS ", value: "SMS " },
];
const taxPreferencesOptions = [
    { label: "Taxable", value: "Taxable" },
    { label: "Tax Exempt", value: "Tax Exempt" },
];
const paymentTearmsOptions = [
    { name: "Net 15", value: "Net 15" },
    { name: "Net 30", value: "Net 30" },
    { name: "Net 45", value: "Net 45" },
    { name: "Net 60", value: "Net 60" },
    { name: "Due On Receipt", value: "Due On Receipt" },
    { name: "Due end of the month", value: "Due end of the month" },
    { name: "Due end of the next month", value: "Due end of the next month" },
];

const AddUpdateCustomer = ({ setIsOpenAddUpdateCustomer, setCustomerData, customerData, selectedCustomerData, setSelectedCustomerData, _getListData, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Basic Details", value: 0 });
    const [errors, setErrors] = useState({});

    const [countryPage, setCountryPage] = useState(1);
    const [countryTotalCount, setCountryTotalCount] = useState();
    const [countryList, setCountryList] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [searchCountry, setSearchCountry] = useState();

    const [cityPage, setCityPage] = useState(1);
    const [cityTotalCount, setCityTotalCount] = useState();
    const [cityList, setCityList] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [searchCity, setSearchCity] = useState();

    const [statePage, setStatePage] = useState(1);
    const [stateTotalCount, setStateTotalCount] = useState();
    const [stateList, setStateList] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [searchState, setSearchState] = useState();

    const [shippingCountryPage, setShippingCountryPage] = useState(1);
    const [shippingCountryTotalCount, setShippingCountryTotalCount] = useState();
    const [shippingCountryList, setShippingCountryList] = useState([]);
    const [shippingCountryOptions, setShippingCountryOptions] = useState([]);
    const [searchShippingCountry, setSearchShippingCountry] = useState();

    const [shippingStatePage, setShippingStatePage] = useState(1);
    const [shippingStateTotalCount, setShippingStateTotalCount] = useState();
    const [shippingStateList, setShippingStateList] = useState([]);
    const [shippingStateOptions, setShippingStateOptions] = useState([]);
    const [searchShippingState, setSearchShippingState] = useState();

    const [shippingCityPage, setShippingCityPage] = useState(1);
    const [shippingCityTotalCount, setShippingCityTotalCount] = useState();
    const [shippingCityList, setShippingCityList] = useState([]);
    const [shippingCityOptions, setShippingCityOptions] = useState([]);
    const [searchShippingCity, setSearchShippingCity] = useState();

    // ============== Handler ==============
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdateCustomer(false); setCustomerData({}); setSearchValue('') }}>
            Invoice
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {selectedCustomerData?._id ? "Edit Customer" : "Create Customer"}
        </Typography>,
    ];
    const handleUpdatePreviousValue = () => {
        const temp = customerStep?.find((ele) => ele?.value == value - 1)
        setValue(value - 1)
        setActiveTab(temp)
    }
    const handleUpdateNextValue = () => {
        if (validation()) {
            const temp = customerStep?.find((ele) => ele?.value == value + 1)
            if (temp) {
                setValue(value + 1)
                setActiveTab(temp)
            } else {
                _addUpdateCustomer();
            }
        }
    }
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange = (name, value) => {
        if (name == "billingCountry") {
            setCustomerData({ ...customerData, [name]: value, billingState: "", billingCity: "" })
            setCityList([])
            setStateList([])
        } else if (name == "billingState") {
            setCustomerData({ ...customerData, [name]: value, billingCity: "" })
            setCityList([])
        } else if (name == "shippingCountry") {
            setCustomerData({ ...customerData, [name]: value, shippingState: "", shippingCity: "" })
            setShippingStateList([])
            setShippingCityList([])
        } else if (name == "shippingState") {
            setCustomerData({ ...customerData, [name]: value, shippingCity: "" })
            setShippingCityList([])
        } else {
            setCustomerData({ ...customerData, [name]: value })
        }
    }



    // =============== Validations ===============
    const validation = () => {
        let formIsValid = true;
        let errors = {}
        if (activeTab?.value == 0) {
            if (!customerData?.emailId) {
                formIsValid = false;
                errors["emailId"] = "* Please enter email";
            } else if (!customerData.emailId?.match(Regex.emailRegex)) {
                formIsValid = false;
                errors["invalidEmail"] = "* Invalid email Address";
            }
            if (!customerData?.companyName) {
                formIsValid = false;
                errors["companyName"] = "* Please Enter Company Name.";
            }
            if (!customerData?.location) {
                formIsValid = false;
                errors["location"] = "* Please Select location.";
            }
            if (!customerData?.status) {
                formIsValid = false;
                errors["status"] = "* Please Select status.";
            }
            if (customerData.privacyContact) {
                if (customerData.privacyContact.length < 7 || customerData.privacyContact.length > 15) {
                    formIsValid = false;
                    errors["privacyContact"] = "* Privacy Contact must be between 7 and 15 digits.";
                }
            }
            if (customerData.phoneNumber) {
                if (customerData.phoneNumber.length < 7 || customerData.phoneNumber.length > 15) {
                    formIsValid = false;
                    errors["phoneNumber"] = "* Phone Number must be between 7 and 15 digits.";
                }
            }
        }
        else if (activeTab?.value == 1) {
            if (!customerData?.panNumber) {
                formIsValid = false;
                errors["panNumber"] = "* Please Enter Pan Card Number";
            } else if (!customerData?.panNumber?.match(Regex.panRegex)) {
                formIsValid = false;
                errors["invalidPancardNumber"] = "* Invalid Pan Card Number";
            } else if (customerData?.panNumber.length < 10) {
                formIsValid = false;
                errors["invalidPancardNumberMin"] = "* Pan Card Number must be at least 10 characters long";
            } else if (customerData?.panNumber !== customerData?.panNumber.toUpperCase()) {
                formIsValid = false;
                errors["invalidPancardNumberUper"] = "* Pan Card Number must be in uppercase";
            }
            if (customerData?.websiteURL) {
                if (!customerData.websiteURL.match(Regex.webSiteURL)) {
                    formIsValid = false;
                    errors["invalidWebsiteURL"] = "* Invalid Website URL";
                }
            }
            if (customerData?.facebook) {
                const facebookRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(.?)?]/;
                if (!customerData.facebook.match(facebookRegex)) {
                    formIsValid = false;
                    errors["invalidFacebook"] = "* Invalid Facebook Profile Link";
                }
            }
            if (customerData?.twitter) {
                const twitterRegex = /^(https?:\/\/)?(www\.)?twitter\.com\/([a-zA-Z0-9_]+)$/;
                if (!customerData.twitter.match(twitterRegex)) {
                    formIsValid = false;
                    errors["invalidTwitter"] = "* Invalid Twitter Profile Link";
                }
            }
            // if (customerData?.skypeNumber) {
            //     if (customerData.skypeNumber.length < 7 || customerData.skypeNumber.length > 15) {
            //         formIsValid = false;
            //         errors["invalidSkype"] = "* Skype Number must be between 7 and 15 digits.";
            //     }
            // }
        } else if (activeTab?.value == 2) {
            if (customerData?.billingPinCode) {
                if (customerData?.billingPinCode?.length !== 6) {
                    formIsValid = false;
                    errors['invalidBillingPincode'] = "* Invalid Pincode"
                }
            }
            if (customerData?.shippingPinCode) {
                if (customerData?.shippingPinCode?.length !== 6) {
                    formIsValid = false;
                    errors['invalidShippingPincode'] = "* Invalid Pincode"
                }
            }
            if (customerData.billingPhoneNumber) {
                if (customerData.billingPhoneNumber.length < 7 || customerData.billingPhoneNumber.length > 15) {
                    formIsValid = false;
                    errors["billingPhoneNumber"] = "* Phone Number must be between 7 and 15 digits.";
                }
            }
            if (customerData.shippingPhoneNumber) {
                if (customerData.shippingPhoneNumber.length < 7 || customerData.shippingPhoneNumber.length > 15) {
                    formIsValid = false;
                    errors["shippingPhoneNumber"] = "* Phone Number must be between 7 and 15 digits.";
                }
            }
            if (customerData?.billingFaxNumber) {
                if (!/^\d{7,15}$/.test(customerData.billingFaxNumber)) {
                    formIsValid = false;
                    errors["billingFaxNumber"] = "* Fax Number must be between 7 to 15 digits.";
                }
            }
            if (customerData?.shippingFaxNumber) {
                if (!/^\d{7,15}$/.test(customerData.shippingFaxNumber)) {
                    formIsValid = false;
                    errors["shippingFaxNumber"] = "* Fax Number must be between 7 to 15 digits.";
                }
            }
        } else if (activeTab?.value == 3) {
            if (!customerData?.contactPersonEmailId) {
                formIsValid = false;
                errors["contactPersonEmailId"] = "* Please enter email";
            } else if (!customerData.contactPersonEmailId?.match(Regex.emailRegex)) {
                formIsValid = false;
                errors["ContactPersonInvalidEmail"] = "* Invalid email Address";
            }
            if (!customerData?.contactPersonSalutation) {
                formIsValid = false;
                errors["contactPersonSalutation"] = "* Please Enter Contact Person Salutation.";
            }
            if (!customerData?.contactPersonFirstName) {
                formIsValid = false;
                errors["contactPersonFirstName"] = "* Please Enter Contact Person From Name.";
            }

        } else {
            if (!customerData?.emailId) {
                formIsValid = false;
                setSnackBar('error', "* Please enter email in basic details.")
            } else if (!customerData.emailId?.match(Regex.emailRegex)) {
                formIsValid = false;
                setSnackBar('error', "* Invalid email address in basic details.")
            }
            if (!customerData?.companyName) {
                formIsValid = false;
                setSnackBar('error', "* Please Enter Company Name in basic details.")
            }
            if (!customerData?.location) {
                formIsValid = false;
                setSnackBar('error', "* Please Select location in basic details.")
            }
            if (!customerData?.status) {
                formIsValid = false;
                setSnackBar('error', "* Please Select status in basic details.")
            }
            if (!customerData?.panNumber) {
                formIsValid = false;
                setSnackBar('error', "* Please Enter Pan Card Number In Other Details.")
            } else if (!customerData?.panNumber?.match(Regex.panRegex)) {
                formIsValid = false;
                setSnackBar('error', "* invalid pan card number in other details.")
            } else if (customerData?.panNumber.length < 10) {
                formIsValid = false;
                setSnackBar('error', "* Pan card number must be at least 10 characters long in other details.")
            } else if (customerData?.panNumber !== customerData?.panNumber.toUpperCase()) {
                formIsValid = false;
                setSnackBar('error', "* Pan card number must be in uppercase in other details.")
            }
            if (customerData.privacyContact) {
                if (customerData.privacyContact.length < 7 || customerData.privacyContact.length > 15) {
                    formIsValid = false;
                    setSnackBar('error', "* Privacy Contact must be between 7 and 15 digits in basic details")
                }
            }
            if (customerData.phoneNumber) {
                if (customerData.phoneNumber.length < 7 || customerData.phoneNumber.length > 15) {
                    formIsValid = false;
                    setSnackBar('error', "* Phone Number must be between 7 and 15 digits in basic details")
                }
            }
            if (customerData?.websiteURL) {
                if (!customerData.websiteURL.match(Regex.webSiteURL)) {
                    formIsValid = false;
                    setSnackBar('error', "* Invalid Website URL in other details.")
                }
            }
            if (customerData?.facebook) {
                const facebookRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(.?)?]/;
                if (!customerData.facebook.match(facebookRegex)) {
                    formIsValid = false;
                    setSnackBar('error', "* Invalid Facebook Profile Link in other details.")
                }
            }
            if (customerData?.twitter) {
                const twitterRegex = /^(https?:\/\/)?(www\.)?twitter\.com\/([a-zA-Z0-9_]+)$/;
                if (!customerData.twitter.match(twitterRegex)) {
                    formIsValid = false;
                    setSnackBar('error', "* Invalid Twitter Profile Link in other details.")
                }
            }
            // if (customerData?.skypeNumber) {
            //     if (customerData?.skypeNumber.length < 7 || customerData.skypeNumber.length > 15) {
            //         formIsValid = false;
            //         setSnackBar('error', "* Skype Number must be between 7 and 15 digits.")
            //     }
            // }
            if (customerData?.billingPinCode) {
                if (customerData?.billingPinCode?.length !== 6) {
                    formIsValid = false;
                    setSnackBar('error', "* Invalid pincode in billing address.")
                }
            }
            if (customerData?.shippingPinCode) {
                if (customerData?.shippingPinCode?.length !== 6) {
                    formIsValid = false;
                    setSnackBar('error', "* Invalid pincode in shipping address.")
                }
            }
            if (customerData.billingPhoneNumber) {
                if (customerData.billingPhoneNumber.length < 7 || customerData.billingPhoneNumber.length > 15) {
                    formIsValid = false;
                    setSnackBar('error', "* billing Phone Number must be between 7 and 15 digits in shipping address.")
                }
            }
            if (customerData.shippingPhoneNumber) {
                if (customerData.shippingPhoneNumber.length < 7 || customerData.shippingPhoneNumber.length > 15) {
                    formIsValid = false;
                    setSnackBar('error', "* shipping Phone Number must be between 7 and 15 digits in shipping address.")
                }
            }
            if (customerData?.shippingFaxNumber) {
                if (!/^\d{7,15}$/.test(customerData.shippingFaxNumber)) {
                    formIsValid = false;
                    setSnackBar('error', "* shipping fax Number must be between 7 and 15 digits in shipping address.")
                }
            }
            if (customerData?.billingFaxNumber) {
                if (!/^\d{7,15}$/.test(customerData.billingFaxNumber)) {
                    formIsValid = false;
                    setSnackBar('error', "* billing fax Number must be between 7 and 15 digits in shipping address.")
                }
            }
            if (!customerData?.contactPersonEmailId) {
                formIsValid = false;
                setSnackBar('error', "* Please enter contact person email")
            } else if (!customerData.contactPersonEmailId?.match(Regex.emailRegex)) {
                formIsValid = false;
                setSnackBar('error', "* Please enter valid contact person email.")
            }
            if (!customerData?.contactPersonSalutation) {
                formIsValid = false;
                setSnackBar('error', "* Please Select Contact Person Salutation.")
            }
            if (!customerData?.contactPersonFirstName) {
                formIsValid = false;
                setSnackBar('error', "* Please Enter Contact Person From Name.")
            }

        }

        setErrors(errors)
        return formIsValid
    }


    const handleUploadImg = async (files, fieldName) => {
        setFullPageLoader(true);
        let response;
        const formData = new FormData();
        formData.append("image", files[0]);
        response = await dispatch(image(formData));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                const imageUrl = response?.payload?.data?.[0]?.image;
                if (imageUrl) {
                    setCustomerData((prev) => ({
                        ...prev,
                        [fieldName]: imageUrl,
                    }));
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    //------------------  Country API ------------------
    const _getCountry = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : countryPage,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAllStateAndCity(body));
        { (countryList?.length !== countryTotalCount) && setCountryPage(countryPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCountry(searchText ? searchText : "");
            setCountryTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != countryList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setCountryList([...countryList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForCountry = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAllStateAndCity(body));
        setCountryPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCountry(searchText);
            setCountryList(response?.payload?.data?.response);
        }
    };

    //------------------  City API ------------------
    const _getCity = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : cityPage,
            "search": searchText ? searchText : "",
            "countryName": customerData?.billingCountry,
            "stateName": customerData?.billingState,
        };
        response = await dispatch(getAllStateAndCity(body));
        { (cityList?.length !== cityTotalCount) && setCityPage(cityPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCity(searchText ? searchText : "");
            setCityTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != cityList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setCityList([...cityList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForCity = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "countryName": customerData?.billingCountry,
            "stateName": customerData?.billingState,
        };
        response = await dispatch(getAllStateAndCity(body));
        setCityPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchCity(searchText);
            setCityList(response?.payload?.data?.response);
        }
    };

    //------------------  State API ------------------
    const _getState = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : statePage,
            "search": searchText ? searchText : "",
            "countryName": customerData?.billingCountry
        };
        response = await dispatch(getAllStateAndCity(body));
        { (stateList?.length !== stateTotalCount) && setStatePage(statePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchState(searchText ? searchText : "");
            setStateTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != stateList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setStateList([...stateList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForState = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "countryName": customerData?.billingCountry
        };
        response = await dispatch(getAllStateAndCity(body));
        setStatePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchState(searchText);
            setStateList(response?.payload?.data?.response);
        }
    };

    //------------------  Shipping Country API ------------------
    const _getShippingCountry = async (p, searchText) => {
        let response;
        let body = {

            "limit": 10,
            "page": p ? p : shippingCountryPage,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAllStateAndCity(body));
        { (shippingCountryList?.length !== shippingCountryTotalCount) && setShippingCountryPage(shippingCountryPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingCountry(searchText ? searchText : "");
            setShippingCountryTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != shippingCountryList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setShippingCountryList([...shippingCountryList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForShippingCountry = async (p, searchText) => {
        let response;
        let body = {

            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAllStateAndCity(body));
        setShippingCountryPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingCountry(searchText);
            setShippingCountryList(response?.payload?.data?.response);
        }
    };
    //------------------  Shipping State API ------------------
    const _getShippingState = async (p, searchText) => {
        let response;
        let body = {

            "limit": 10,
            "page": p ? p : shippingStatePage,
            "search": searchText ? searchText : "",
            "countryName": customerData?.shippingCountry
        };
        response = await dispatch(getAllStateAndCity(body));
        { (shippingStateList?.length !== shippingStateTotalCount) && setShippingStatePage(shippingStatePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingState(searchText ? searchText : "");
            setShippingStateTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != shippingStateList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setShippingStateList([...shippingStateList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForShippingState = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "countryName": customerData?.shippingCountry
        };
        response = await dispatch(getAllStateAndCity(body));
        setShippingStatePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingState(searchText);
            setShippingStateList(response?.payload?.data?.response);
        }
    };

    //------------------  Shipping City API ------------------
    const _getShippingCity = async (p, searchText) => {
        let response;
        let body = {

            "limit": 10,
            "page": p ? p : shippingCityPage,
            "search": searchText ? searchText : "",
            "countryName": customerData?.shippingCountry,
            "stateName": customerData?.shippingState,
        };
        response = await dispatch(getAllStateAndCity(body));
        { (shippingCityList?.length !== shippingCityTotalCount) && setShippingCityPage(shippingCityPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingCity(searchText ? searchText : "");
            setShippingCityTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != shippingCityList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    setShippingCityList([...shippingCityList, ...response?.payload?.data?.response]);
                }
            }
        }
    };

    const handleChangeInputForShippingCity = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "countryName": customerData?.shippingCountry,
            "stateName": customerData?.shippingState,
        };
        response = await dispatch(getAllStateAndCity(body));
        setShippingCityPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchShippingCity(searchText);
            setShippingCityList(response?.payload?.data?.response);
        }
    };


    // ============= add Invoice API =============
    const _addUpdateCustomer = async () => {
        if (validation()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "basicDetails": {
                    "companyName": customerData?.companyName,
                    "displayName": customerData?.displayName,
                    "phone": +customerData?.phoneNumber,
                    "email": customerData?.emailId,
                    "location": customerData?.location?.value,
                    "privacyContact": customerData?.privacyContact,
                    "status": customerData?.status,
                    "communicationChannel": customerData?.communicationChannel
                },
                "otherDetails": {
                    "GSTTreatment": customerData?.gstTreatment?.value,
                    "placeOfSupply": customerData?.placeOfSupply?.value,
                    "panNumber": customerData?.panNumber,
                    "openingBalance": +customerData?.openingBalance,
                    "currency": customerData?.currency?.name,
                    "taxPreference": customerData?.taxPreference,
                    "paymentTearms": customerData?.paymentTerms?.value,
                    "document": customerData?.document,
                    "websiteUrl": customerData?.websiteURL,
                    "twitter": customerData?.twitter,
                    "skypeNameNumber": customerData?.skypeNumber,
                    "facebook": customerData?.facebook,
                    "department": customerData?.department,
                    "designation": customerData?.designation
                },
                "addressDetail": {
                    "billingAddress": {
                        "attention": customerData?.billingAttention,
                        "address": customerData?.billingAddress,
                        "city": customerData?.billingCity,
                        "state": customerData?.billingState,
                        "zipCode": customerData?.billingPinCode,
                        "country": customerData?.billingCountry,
                        "phone": customerData?.billingPhoneNumber,
                        "faxNumber": customerData?.billingFaxNumber
                    },
                    "sameAsBillingAddress": customerData?.sameAsBillingAddress,
                    "shippingAddress": {
                        "attention": customerData?.shippingAttention,
                        "address": customerData?.shippingAddress,
                        "city": customerData?.shippingCity,
                        "state": customerData?.shippingState,
                        "zipCode": customerData?.shippingPinCode,
                        "country": customerData?.shippingCountry,
                        "phone": customerData?.shippingPhoneNumber,
                        "faxNumber": customerData?.shippingFaxNumber
                    }
                },
                "contactPersonDetail": {
                    "salutation": customerData?.contactPersonSalutation,
                    "firstName": customerData?.contactPersonFirstName,
                    "lastName": customerData?.contactPersonLastName,
                    "email": customerData?.contactPersonEmailId,
                    "phoneNumber": +customerData?.contactPersonPhoneNumber,
                    "mobileNumber": +customerData?.contactPersonPhoneNumberWork
                },
                "remark": customerData?.remark
            }

            if (selectedCustomerData?._id) {
                body._id = selectedCustomerData?._id
            }
            const fn = selectedCustomerData?._id ? updateCustomer : addCustomer
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setIsOpenAddUpdateCustomer(false);
                    setSelectedCustomerData([]);
                    setCustomerData({});
                    _getListData();
                    setSearchValue('')
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    }

    // ================ Use Effect ================

    useEffect(() => {
        _getCountry(1);
        _getShippingCountry(1);
    }, []);

    useEffect(() => {
        if (customerData?.billingCountry) {
            _getState(1);
        }
    }, [customerData?.billingCountry])

    useEffect(() => {
        if (customerData?.billingState) {
            _getCity(1);
        }
    }, [customerData?.billingState])

    useEffect(() => {
        if (customerData?.shippingCountry) {
            _getShippingState(1);
        }
    }, [customerData?.shippingCountry]);

    useEffect(() => {
        if (customerData?.shippingState) {
            _getShippingCity(1);
        }
    }, [customerData?.shippingState]);



    useEffect(() => {
        setCountryOptions(countryList?.map((e) => e));
    }, [countryList]);

    useEffect(() => {
        setStateOptions(stateList?.map((e) => e));
    }, [stateList]);

    useEffect(() => {
        setCityOptions(cityList?.map((e) => e));
    }, [cityList]);

    useEffect(() => {
        setShippingCountryOptions(shippingCountryList?.map((e) => e));
    }, [shippingCountryList]);

    useEffect(() => {
        setShippingStateOptions(shippingStateList?.map((e) => e));
    }, [shippingStateList]);

    useEffect(() => {
        setShippingCityOptions(shippingCityList?.map((e) => e));
    }, [shippingCityList]);

    return (
        <Box display={"flex"}>
            <Box sx={{ minWidth: "275px", height: "calc(100vh - 84px)", backgroundColor: "#E2E4F8" }}>
                <Tabs value={value} onChange={handleChangeTab} className={muiClasses.customTabStyle}
                    orientation="vertical">
                    {customerStep.map((ele, index) => (
                        <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                    ))}
                </Tabs>
            </Box>
            <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
                <Grid item xs={12}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{selectedCustomerData?._id ? "Edit Customer" : "Create Customer"}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px", maxHeight: "64vh", overflowY: "auto" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>{activeTab?.value == 2 ? "Billing Address" : activeTab.name}</Typography>
                            </Grid>
                            {activeTab?.value == 0 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            valid
                                            label="Company Name"
                                            name="companyName"
                                            value={customerData?.companyName}
                                            placeholder="Enter Company Name"
                                            onChange={(e) => handleChange("companyName", e.target.value)}
                                        />
                                        <ErrorMessage text={!customerData.companyName ? errors?.companyName : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            label="Display Name"
                                            placeholder="Enter Display Name"
                                            name="displayName"
                                            value={customerData?.displayName}
                                            onChange={(e) => handleChange("displayName", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Phone"
                                            name="phoneNumber"
                                            value={customerData?.phoneNumber}
                                            placeholder="Enter Your Phone No."
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 999999999999999) {
                                                    handleChange("phoneNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={(customerData?.phoneNumber && (customerData.phoneNumber.length < 7 || customerData.phoneNumber.length > 15)) ? errors?.phoneNumber : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            valid
                                            type="text"
                                            label="Email"
                                            placeholder="Enter Your Email address"
                                            name="emailId"
                                            value={customerData.emailId}
                                            onChange={(e) => handleChange("emailId", e.target.value)}
                                        />
                                        <ErrorMessage text={!customerData.emailId ? errors?.emailId : ""} />
                                        <ErrorMessage text={(customerData.emailId && !customerData.emailId?.match(Regex.emailRegex)) ? errors?.invalidEmail : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="Location"
                                            valid
                                            placeholder="Select Location"
                                            options={placeOfSupplyOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={customerData?.location || null}
                                            onChange={(e, newValue) => handleChange("location", newValue)}
                                        />
                                        <ErrorMessage text={!customerData?.location ? errors?.location : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Privacy Contact"
                                            name="privacyContact"
                                            value={customerData?.privacyContact}
                                            placeholder="Enter Privacy Contact"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 999999999999999) {
                                                    handleChange("privacyContact", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={(customerData?.privacyContact && (customerData.privacyContact.length < 7 || customerData.privacyContact.length > 15)) ? errors?.privacyContact : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Typography fontSize={'14px'} fontFamily={"Satoshi-Medium"} mb={2}>Status <span style={{ color: theme.palette.error.main }}>*</span> </Typography>
                                        <CommonRadioButton
                                            valid
                                            radioLabels={statusOptions}
                                            name="status"
                                            selectedValue={customerData.status}
                                            handleChange={(e) =>
                                                handleChange("status", e.target.value)
                                            }
                                        /><br />
                                        <ErrorMessage text={!customerData?.status ? errors?.status : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Typography fontSize={'14px'} fontFamily={"Satoshi-Medium"} mb={2}>Communication Channels</Typography>
                                        <CommonRadioButton
                                            radioLabels={communicationChannelsOptions}
                                            name="communicationChannel"
                                            selectedValue={customerData.communicationChannel}
                                            handleChange={(e) =>
                                                handleChange("communicationChannel", e.target.value)
                                            }
                                        />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 1 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="GST Treatment"
                                            placeholder="Select GST Treatment"
                                            options={yesNoOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={customerData?.gstTreatment || null}
                                            onChange={(e, newValue) => handleChange("gstTreatment", newValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="Place Of Supply"
                                            placeholder="Select Place Of Supply"
                                            options={placeOfSupplyOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={customerData?.placeOfSupply || null}
                                            onChange={(e, newValue) => handleChange("placeOfSupply", newValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            valid
                                            type="text"
                                            label="PAN Number"
                                            placeholder="Enter Your PAN Number"
                                            name="panNumber"
                                            value={customerData.panNumber}
                                            onChange={(e) => handleChange("panNumber", e.target.value)}
                                        />
                                        <ErrorMessage text={!customerData?.panNumber ? errors?.panNumber : ""} />
                                        <ErrorMessage text={customerData?.panNumber?.match(Regex.panRegex) ? "" : errors["invalidPancardNumber"]} />
                                        <ErrorMessage text={customerData?.panNumber?.length > 10 ? "" : errors["invalidPancardNumberMin"]} />
                                        <ErrorMessage text={customerData?.panNumber === customerData?.panNumber?.toUpperCase() ? "" : errors["invalidPancardNumberUper"]} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Opening Balance"
                                            placeholder="Enter Your Opening Balance"
                                            name="openingBalance"
                                            value={customerData.openingBalance}
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("openingBalance", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label={"Currency"}
                                            placeholder="Select Currency"
                                            options={currencyOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={customerData?.currency || null}
                                            onChange={(e, newValue) => handleChange("currency", newValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Typography fontSize={'14px'} fontFamily={"Satoshi-Medium"} mb={2}>Tax Preference</Typography>
                                        <CommonRadioButton
                                            radioLabels={taxPreferencesOptions}
                                            name="taxPreference"
                                            selectedValue={customerData.taxPreference}
                                            handleChange={(e) =>
                                                handleChange("taxPreference", e.target.value)
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label={"Payment Terms"}
                                            placeholder="Select Payment Terms"
                                            options={paymentTearmsOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={customerData?.paymentTerms || null}
                                            onChange={(e, newValue) => handleChange("paymentTerms", newValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <CommonLabel title={'Upload Document'} />
                                        <CommonFileUpload
                                            value={customerData?.document}
                                            handleImageChange={(files) => handleUploadImg(files, "document")}
                                            accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                            handleSingleDelete={() => setCustomerData({ ...customerData, document: "" })}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Website URL"
                                            placeholder="Enter Website URL"
                                            name="websiteURL"
                                            value={customerData.websiteURL}
                                            onChange={(e) => handleChange("websiteURL", e.target.value)}
                                        />
                                        <ErrorMessage text={(customerData.websiteURL && !customerData.websiteURL?.match(Regex.webSiteURL)) ? errors?.invalidWebsiteURL : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Twitter"
                                            placeholder="Enter Twitter Profile"
                                            name="twitter"
                                            value={customerData.twitter}
                                            onChange={(e) => handleChange("twitter", e.target.value)}
                                        />
                                        <ErrorMessage text={customerData?.twitter && !customerData.twitter.match(/^(https?:\/\/)?(www\.)?twitter\.com\/([a-zA-Z0-9_]+)$/) ? "* Invalid Twitter Profile Link" : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Skype Name/Number"
                                            placeholder="Enter Skype Name/Number"
                                            name="skypeNumber"
                                            value={customerData.skypeNumber}
                                            onChange={(e) => handleChange("skypeNumber", e.target.value)}
                                        />
                                        {/* <ErrorMessage text={(customerData?.skypeNumber && !/^\d{7,15}$/.test(customerData.skypeNumber)) ? "* Fax Number must be between 7 to 15 digits." : ""} /> */}
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Facebook"
                                            placeholder="Enter Facebook Profile"
                                            name="facebook"
                                            value={customerData.facebook}
                                            onChange={(e) => handleChange("facebook", e.target.value)}
                                        />

                                        <ErrorMessage text={customerData?.facebook && !customerData.facebook.match(/^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9(.?)?]/) ? "* Invalid Facebook Profile Link" : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Department"
                                            placeholder="Enter Department"
                                            name="department"
                                            value={customerData.department}
                                            onChange={(e) => handleChange("department", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <CommonTextField
                                            type="text"
                                            label="Designation"
                                            placeholder="Enter Designation"
                                            name="designation"
                                            value={customerData.designation}
                                            onChange={(e) => handleChange("designation", e.target.value)}
                                        />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 2 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            label="Attention"
                                            placeholder="Enter Attention"
                                            name="billingAttention"
                                            value={customerData.billingAttention}
                                            onChange={(e) => handleChange("billingAttention", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="Country"
                                            placeholder="Select Country"
                                            options={countryOptions || []}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.billingCountry || null}
                                            onChange={(e, newValue) => handleChange("billingCountry", newValue)}
                                            loadData={(countryOptions?.length !== countryTotalCount) ? _getCountry : undefined}
                                            handleSearch={(e) => handleChangeInputForCountry(1, e?.target?.value)}
                                            searchValue={searchCountry}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Phone"
                                            name="billingPhoneNumber"
                                            value={customerData?.billingPhoneNumber}
                                            placeholder="Enter Your Phone No."
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 999999999999999) {
                                                    handleChange("billingPhoneNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={(customerData?.billingPhoneNumber && (customerData?.billingPhoneNumber.length < 7 || customerData?.billingPhoneNumber.length > 15)) ? errors?.billingPhoneNumber : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={8}>
                                        <CommonTextField
                                            type="text"
                                            label="Address"
                                            placeholder="Enter Address"
                                            name="billingAddress"
                                            value={customerData.billingAddress}
                                            onChange={(e) => handleChange("billingAddress", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="State"
                                            placeholder="Select State"
                                            options={stateOptions || []}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.billingState || null}
                                            onChange={(e, newValue) => handleChange("billingState", newValue)}
                                            loadData={(stateOptions?.length !== stateTotalCount) ? _getState : undefined}
                                            handleSearch={(e) => handleChangeInputForState(1, e?.target?.value)}
                                            searchValue={searchState}
                                        />

                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="City"
                                            placeholder="Select City"
                                            options={cityOptions || []}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.billingCity || null}
                                            onChange={(e, newValue) => handleChange("billingCity", newValue)}
                                            loadData={(cityOptions?.length !== cityTotalCount) ? _getCity : undefined}
                                            handleSearch={(e) => handleChangeInputForCity(1, e?.target?.value)}
                                            searchValue={searchCity}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Pin Code"
                                            name="billingPinCode"
                                            value={customerData?.billingPinCode}
                                            placeholder="Enter Pin Code"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 999999) {
                                                    handleChange("billingPinCode", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={customerData?.billingPinCode && customerData?.billingPinCode?.length !== 6 ? errors.invalidBillingPincode : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Fax Number"
                                            name="billingFaxNumber"
                                            value={customerData?.billingFaxNumber}
                                            placeholder="Enter Fax Number"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("billingFaxNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={(customerData?.billingFaxNumber && !/^\d{7,15}$/.test(customerData.billingFaxNumber)) ? "* Fax Number must be between 7 to 15 digits." : ""} />
                                    </Grid>
                                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>{"Shipping Address"}</Typography>
                                        <FormControl component="fieldset">
                                            <FormGroup aria-label="position">
                                                <FormControlLabel
                                                    value="sameAsBillingAddress"
                                                    control={<Checkbox checked={customerData?.sameAsBillingAddress} onChange={(e) => handleChange("sameAsBillingAddress", e.target.checked)} />}
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={"Same As Billing Address "}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            label="Attention"
                                            placeholder="Enter Attention"
                                            name="shippingAttention"
                                            disabled={customerData?.sameAsBillingAddress}
                                            value={customerData?.sameAsBillingAddress ? customerData.billingAttention : (customerData.shippingAttention || "")}
                                            onChange={(e) => handleChange("shippingAttention", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="Country"
                                            placeholder="Select Country"
                                            disabled={customerData?.sameAsBillingAddress}
                                            options={shippingCountryOptions || []}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.sameAsBillingAddress ? (customerData?.billingCountry || null) : (customerData?.shippingCountry || null)}
                                            onChange={(e, newValue) => handleChange("shippingCountry", newValue)}
                                            loadData={(shippingCountryOptions?.length !== shippingCountryTotalCount) ? _getShippingCountry : undefined}
                                            handleSearch={(e) => handleChangeInputForShippingCountry(1, e?.target?.value)}
                                            searchValue={searchShippingCountry}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Phone"
                                            name="shippingPhoneNumber"
                                            disabled={customerData?.sameAsBillingAddress}
                                            value={customerData?.sameAsBillingAddress ? customerData?.billingPhoneNumber : (customerData?.shippingPhoneNumber || "")}
                                            placeholder="Enter Your Phone No."
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 9999999999) {
                                                    handleChange("shippingPhoneNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />

                                        <ErrorMessage text={(customerData?.shippingPhoneNumber && (customerData?.shippingPhoneNumber.length < 7 || customerData?.shippingPhoneNumber.length > 15)) ? errors?.shippingPhoneNumber : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={8}>
                                        <CommonTextField
                                            type="text"
                                            label="Address"
                                            disabled={customerData?.sameAsBillingAddress}
                                            placeholder="Enter Address"
                                            name="shippingAddress"
                                            value={customerData?.sameAsBillingAddress ? customerData.billingAddress : (customerData.shippingAddress || "")}
                                            onChange={(e) => handleChange("shippingAddress", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="State"
                                            placeholder="Select State"
                                            options={shippingStateOptions || []}
                                            disabled={customerData?.sameAsBillingAddress}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.sameAsBillingAddress ? (customerData?.billingState || null) : (customerData?.shippingState || null)}
                                            onChange={(e, newValue) => handleChange("shippingState", newValue)}
                                            loadData={(shippingStateOptions?.length !== shippingStateTotalCount) ? _getShippingState : undefined}
                                            handleSearch={(e) => handleChangeInputForShippingState(1, e?.target?.value)}
                                            searchValue={searchShippingState}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            label="City"
                                            placeholder="Select City"
                                            options={shippingCityOptions || []}
                                            disabled={customerData?.sameAsBillingAddress}
                                            getOptionLabel={(option) => option || ""}
                                            value={customerData?.sameAsBillingAddress ? (customerData?.billingCity || null) : (customerData?.shippingCity || null)}
                                            onChange={(e, newValue) => handleChange("shippingCity", newValue)}
                                            loadData={(shippingCityOptions?.length !== shippingCityTotalCount) ? _getShippingCity : undefined}
                                            handleSearch={(e) => handleChangeInputForShippingCity(1, e?.target?.value)}
                                            searchValue={searchShippingCity}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Pin Code"
                                            name="shippingPinCode"
                                            disabled={customerData?.sameAsBillingAddress}
                                            value={customerData?.sameAsBillingAddress ? customerData?.billingPinCode : (customerData?.shippingPinCode || "")}
                                            placeholder="Enter Pin Code"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 999999) {
                                                    handleChange("shippingPinCode", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={customerData?.shippingPinCode && customerData?.shippingPinCode?.length !== 6 ? errors.invalidShippingPincode : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Fax Number"
                                            name="shippingFaxNumber"
                                            disabled={customerData?.sameAsBillingAddress}
                                            value={customerData?.sameAsBillingAddress ? customerData?.billingFaxNumber : (customerData?.shippingFaxNumber || "")}
                                            placeholder="Enter Fax Number"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 9999999999) {
                                                    handleChange("shippingFaxNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                        <ErrorMessage text={(customerData?.shippingFaxNumber && !/^\d{7,15}$/.test(customerData.shippingFaxNumber)) ? "* Fax Number must be between 7 to 15 digits." : ""} />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 3 &&
                                <>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonAutoComplete
                                            valid
                                            label="Salutation"
                                            placeholder="Select Salutation"
                                            options={salutationOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={salutationOptions.find(option => option.value === customerData?.contactPersonSalutation) || null}
                                            onChange={(e, newValue) => handleChange("contactPersonSalutation", newValue?.value || "")}
                                        />
                                        <ErrorMessage text={!customerData?.contactPersonSalutation ? errors?.contactPersonSalutation : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            valid
                                            label="First Name"
                                            placeholder="Enter First Name"
                                            name="contactPersonFirstName"
                                            value={customerData.contactPersonFirstName}
                                            onChange={(e) => handleChange("contactPersonFirstName", e.target.value)}
                                        />
                                        <ErrorMessage text={!customerData?.contactPersonFirstName ? errors?.contactPersonFirstName : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="text"
                                            label="Last Name"
                                            placeholder="Enter Last Name"
                                            name="contactPersonLastName"
                                            value={customerData.contactPersonLastName}
                                            onChange={(e) => handleChange("contactPersonLastName", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            valid
                                            type="text"
                                            label="Email"
                                            placeholder="Enter Email address"
                                            name="contactPersonEmailId"
                                            value={customerData.contactPersonEmailId}
                                            onChange={(e) => handleChange("contactPersonEmailId", e.target.value)}
                                        />
                                        <ErrorMessage text={!customerData.contactPersonEmailId ? errors?.contactPersonEmailId : ""} />
                                        <ErrorMessage text={(customerData.contactPersonEmailId && !customerData.contactPersonEmailId?.match(Regex.emailRegex)) ? errors?.ContactPersonInvalidEmail : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Phone Number (Work)"
                                            name="contactPersonPhoneNumberWork"
                                            value={customerData?.contactPersonPhoneNumberWork}
                                            placeholder="Enter Phone No."
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 9999999999) {
                                                    handleChange("contactPersonPhoneNumberWork", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CommonTextField
                                            type="number"
                                            label="Mobile Number"
                                            name="contactPersonPhoneNumber"
                                            value={customerData?.contactPersonPhoneNumber}
                                            placeholder="Enter Phone No."
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0 && +e.target?.value < 9999999999) {
                                                    handleChange("contactPersonPhoneNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                            onKeyDown={allowOnlyNumbers}
                                        />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 4 &&
                                <>
                                    <Grid item xs={12} >
                                        <CommonTextField
                                            type="text"
                                            multiline
                                            rows={4}
                                            label="Remarks (For Internal Use)"
                                            placeholder="Enter Your Remark"
                                            name="remark"
                                            value={customerData?.remark}
                                            onChange={(e) => handleChange("remark", e.target.value)}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12} display={"flex"} gap={2}>
                                {value != 0 &&
                                    <Button className={classes.cancelButton} onClick={() => handleUpdatePreviousValue()} disabled={value == 0}>{activeTab?.value == 0 ? "Cancel" : "Previous"}</Button>
                                }
                                <Button className={classes.saveButton} onClick={() => handleUpdateNextValue()}>{activeTab?.value == 4 ? "Create Customer" : "Save &  Next"}</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddUpdateCustomer